export const getFileExtension = (fileName: string) => {
	if (fileName) {
		// "Document.pdf" => ".pdf"
		return `.${fileName.split('.').pop()}`;
	}
};

const getFileNameWithoutExtension = (fileName: string) => {
	// "Document.pdf" => "Document"
	return fileName.split('.').slice(0, -1).join('.') || fileName;
};

export const replaceSpecialCharsWithSpace = (fileName: string) => {
	// "Document_new.pdf" => "Document new"
	return getFileNameWithoutExtension(fileName)
		.replace(/[_`~!@#$%^&*(){};:'",.?[\]|\s\\|/<>=]+/g, ' ')
		.trim();
};

export const isDocxFile = (fileName: string) => {
	return getFileExtension(fileName) === '.docx';
};
